/**
 * Expose the service definitions
 */
export * from './EVA.Admin.Services.js';
//# sourceMappingURL=eva-services-admin.js.map